import { Modal } from 'antd';
import error from '../../assets/images/error.png';
import FirebaseService from '../../core/services/firebase/firebaseService';
import { useAppSelector } from '../../core/services/hooks';
import Constants from '../../core/utilities/constants';
import { UI } from '../../core/utilities/ui';
import AppButton from '../Buttons/AppButton';
import FirebaseKey from '../FirebaseKey/FirebaseKey';

function ApiErrorModal() {
  const apiError = useAppSelector((state) => state.app.setApiError.error);
  const isConsumed = useAppSelector(
    (state) => state.reward.getReward.data?.consumed
  );

  const isOpen = (): boolean => {
    return !!apiError || !!isConsumed;
  };

  const closeModal = (): void => {
    window.location.href = Constants.closeLink;
  };

  return (
    <Modal
      className="app-modal"
      open={isOpen()}
      closable={false}
      footer={null}
      centered
      destroyOnClose
      onCancel={closeModal}
      styles={{ mask: UI.modalMaskStyle() }}
      width={343}
    >
      <div className="text-center">
        <img className="w-16 mb-3" src={error} alt="error" />
        <h2 className="text-dark text-base font-semibold mt-0 mb-1">
          <FirebaseKey
            firebaseKey={
              isConsumed
                ? FirebaseService.used_link_error_title
                : FirebaseService.error_title
            }
          />
        </h2>
        <p className="text-dark text-base mt-0 mb-4">
          <FirebaseKey
            firebaseKey={
              isConsumed
                ? FirebaseService.used_link_error_desc
                : FirebaseService.error_desc
            }
          />
        </p>
        <AppButton onClick={closeModal}>
          <FirebaseKey
            firebaseKey={
              isConsumed
                ? FirebaseService.used_link_error_button
                : FirebaseService.error_button
            }
          />
        </AppButton>
      </div>
    </Modal>
  );
}

export default ApiErrorModal;
